import React, { useEffect, useState } from 'react'
import { usePrevious } from 'react-use'

import { addAlertSignature } from '../../actions/alerts'
import { UserReducer } from '../../reducers/user'
import { regularComponentDidUpdate } from '../../utils/component-utils'
import { formatError } from '../../utils/error-utils'
import { t } from '../../utils/translation-utils'
import Alert from '../elements/alert'
import Card from '../elements/card'
import Title from '../elements/Title'
import EmailForm, { EmailResult } from './EmailForm'

type Props = {
  user: UserReducer

  addAlert: addAlertSignature
  requestEmailChange: (email: string) => void
}

export default function EmailTab(props: Props) {
  const [error, setError] = useState<Error | null>(null)

  const { user } = props

  useEffect(() => {
    regularComponentDidUpdate(user.error, error, setError)
  }, [user, error])

  const { addAlert } = props
  const previousUser = usePrevious(user)

  useEffect(() => {
    // Check for save callback
    if (previousUser && previousUser.requestingEmailChange && !user.requestingEmailChange) {
      // Check for no error occurred
      if (!user.error) {
        addAlert('success', t('account.message.email_change_success_text'), { timeout: 3 })
      }
    }
  })

  const handleSubmit = (values: EmailResult) => {
    props.requestEmailChange(values.email)
  }

  return (
    <Card>
      <Title>{t('account.email')}</Title>

      {error && <Alert message={formatError(error)} type="error" showIcon />}
      <EmailForm user={props.user} onSubmit={handleSubmit} />
    </Card>
  )
}
